import * as React from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
    icon?: LucideIcon;
    title: string;
    description?: React.ReactNode;
    /** Usually a <Button>. */
    action?: React.ReactNode;
    /** Compact variant for use inside a table body. */
    size?: 'default' | 'sm';
    className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon = Inbox,
    title,
    description,
    action,
    size = 'default',
    className,
}) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center text-center',
                size === 'sm' ? 'py-8' : 'py-12',
                className
            )}
        >
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
                <Icon className="h-6 w-6" />
            </div>
            <p className="mt-4 text-sm font-medium text-foreground">{title}</p>
            {description && (
                <div className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</div>
            )}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
};

export default EmptyState;
